var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalender = function SvgCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.003 14.705h1.95M8.003 16.655v-1.95M16.007 14.705a4.412 4.412 0 0 1-7.75 0M16.507 10.004h-1M12.505 10.004h-1M12.505 10.004h-1M8.504 10.004h-1M7.503 3.001v3.001M16.507 3.001v3.001"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.008,
    height: 16.507,
    x: 3.001,
    y: 4.502,
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 3
  })));
};
export { SvgCalender as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZGQwNGM0NTk3YTkxNGQ0NzlmOWU3ZDM0OWFhY2VhNDQuc3ZnIjs=";